var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"currentColor"},React.createElement("path",{"d":"M130.5 431.485L115.513 409.609 116.246 436.117 91.263 427.228 107.437 448.242 82 455.735 107.437 463.229 91.263 484.243 116.246 475.354 115.513 501.862 130.5 479.985 145.488 501.862 144.754 475.354 169.737 484.243 153.563 463.229 179 455.735 179 455.735 153.563 448.242 169.737 427.228 144.754 436.117 145.488 409.609z","transform":"translate(-82.000000, -409.000000)"}))));
}

Star.defaultProps = {"width":"97","height":"93","viewBox":"0 0 97 93"};

module.exports = Star;

Star.default = Star;
